import React from "react";
import { useNavigate } from "react-router-dom";
import { Star, MapPin, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function ShopCard({ shop, index = 0, onHover }) {
  const navigate = useNavigate();
  return (
    <motion.button
      layout
      data-testid={`shop-card-${shop.id}`}
      onClick={() => navigate(`/shops/${shop.id}`)}
      onMouseEnter={() => onHover && onHover(shop.id)}
      onMouseLeave={() => onHover && onHover(null)}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: Math.min(index * 0.05, 0.4) }}
      className="group text-left w-full bg-card rounded-3xl border border-border overflow-hidden hover:border-primary/40 hover:shadow-[0_20px_50px_-20px_rgba(198,81,47,0.35)] transition-[box-shadow,border-color] duration-400"
    >
      <div className="relative h-44 overflow-hidden">
        <img
          src={shop.images?.[0]}
          alt={shop.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
        />
        <span className="absolute top-3 left-3 text-xs font-bold uppercase tracking-wider bg-background/90 backdrop-blur text-foreground px-3 py-1.5 rounded-full capitalize">
          {shop.category}
        </span>
        {typeof shop.distance_km === "number" && (
          <span className="absolute top-3 right-3 flex items-center gap-1 text-xs font-semibold bg-primary text-primary-foreground px-3 py-1.5 rounded-full">
            <MapPin className="w-3 h-3" /> {shop.distance_km} km
          </span>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display font-bold text-lg leading-tight tracking-tight">
            {shop.name}
          </h3>
          <ArrowUpRight className="w-5 h-5 text-muted-foreground group-hover:text-primary group-hover:rotate-45 transition-transform duration-300 shrink-0" />
        </div>
        <p className="text-sm text-muted-foreground mt-1.5 line-clamp-2 leading-relaxed">
          {shop.description}
        </p>
        <div className="mt-4 flex items-center gap-1.5">
          <Star className="w-4 h-4 fill-primary text-primary" />
          <span className="text-sm font-bold">{shop.rating}</span>
          <span className="text-sm text-muted-foreground">({shop.review_count})</span>
        </div>
      </div>
    </motion.button>
  );
}
